const numberFormats = {
  en: {
    currency: { style: "currency", currency: "USD" },
  },
  zh: {
    currency: { style: "currency", currency: "CNY", currencyDisplay: "code" },
  },
};

export default numberFormats;
